import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIsMobile from '../hooks/useIsMobile';
import api from '../services/api';

function Saldo() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [saldo, setSaldo] = useState(0);
  const [saldoCongelado, setSaldoCongelado] = useState(false);
  const [monto, setMonto] = useState('');
  const [loading, setLoading] = useState(false);
  const [transacciones, setTransacciones] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { cargarDatos(); }, []);

  const cargarDatos = async () => {
    try {
      const [saldoRes, transRes] = await Promise.all([
        api.get('/saldo'),
        api.get('/saldo/transacciones')
      ]);
      setSaldo(saldoRes.data.saldo);
      setSaldoCongelado(saldoRes.data.saldo_congelado || false);
      setTransacciones(transRes.data || []);
    } catch (error) { console.error('Error al cargar datos:', error); }
  };

  const montoNum = parseFloat(monto) || 0;
  const comisionMP = parseFloat((montoNum * 0.04).toFixed(2));
  const montoAcreditado = parseFloat((montoNum - comisionMP).toFixed(2));

  const handleRecargar = async () => {
    if (!monto || parseFloat(monto) < 50) { alert('El monto mínimo es $50 MXN'); return; }
    setLoading(true);
    try {
      const response = await api.post('/pagos/crear-preferencia', { monto: parseFloat(monto) });
      window.location.href = response.data.init_point;
    } catch (error) {
      console.error('Error:', error);
      alert('Error al procesar el pago. Intenta de nuevo.');
      setLoading(false);
    }
  };

  const handleLogout = () => { logout(); navigate('/login'); };
  const [copied, setCopied] = useState('');
  const montosRapidos = [100, 250, 500, 1000, 2500, 5000];

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    setCopied(label);
    setTimeout(() => setCopied(''), 2000);
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      {/* Header */}
      <nav style={{ backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: isMobile ? '0 0.5rem' : '0 1rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', height: isMobile ? '3.5rem' : '4rem', alignItems: 'center' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
              <img src="/logo.png" alt="Logo" style={{ height: isMobile ? '5rem' : '8rem' }} />
            </div>
            {isMobile ? (
              <div style={{ position: 'relative' }}>
                <button onClick={() => setMenuOpen(!menuOpen)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0.5rem' }}>☰</button>
                {menuOpen && (
                  <div style={{ position: 'absolute', right: 0, top: '100%', backgroundColor: 'white', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '0.5rem', padding: '0.5rem', minWidth: '180px', zIndex: 1000 }}>
                    <button onClick={() => { navigate('/dashboard'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Dashboard</button>
                    <button onClick={() => { navigate('/mis-envios'); setMenuOpen(false); }} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Mis Envíos</button>
                    <button onClick={handleLogout} style={{ width: '100%', padding: '0.75rem 1rem', fontSize: '0.875rem', color: '#374151', backgroundColor: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>Cerrar Sesión</button>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button onClick={() => navigate('/dashboard')} style={{ padding: '0.5rem 1rem', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>Dashboard</button>
                <button onClick={() => navigate('/mis-envios')} style={{ padding: '0.5rem 1rem', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>Mis Envíos</button>
                <button onClick={handleLogout} style={{ padding: '0.5rem 1rem', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}>Cerrar Sesión</button>
              </div>
            )}
          </div>
        </div>
      </nav>

      <div style={{ maxWidth: '60rem', margin: '0 auto', padding: isMobile ? '1rem 0.75rem' : '2rem 1rem' }}>
        <h1 style={{ fontSize: isMobile ? '1.25rem' : '1.875rem', fontWeight: 'bold', marginBottom: isMobile ? '1rem' : '2rem' }}>Mi Saldo</h1>

        {saldoCongelado && (
          <div style={{
            backgroundColor: '#fef2f2', border: '2px solid #ef4444', borderRadius: '0.5rem',
            padding: '1rem 1.25rem', marginBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.75rem'
          }}>
            <span style={{ fontSize: '1.5rem' }}>🔒</span>
            <div>
              <div style={{ fontWeight: '700', color: '#991b1b', fontSize: '1rem' }}>Saldo Congelado</div>
              <div style={{ color: '#991b1b', fontSize: '0.875rem' }}>
                Tu saldo está congelado por una revisión en curso. Contacta soporte.
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: isMobile ? '1rem' : '2rem' }}>
          {/* Saldo Actual */}
          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: isMobile ? '1.25rem' : '2rem' }}>
            <h2 style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '0.5rem' }}>Saldo Disponible</h2>
            <div style={{ fontSize: isMobile ? '2.25rem' : '3rem', fontWeight: 'bold', color: '#ff8c00' }}>
              ${parseFloat(saldo).toFixed(2)}
            </div>
            <p style={{ color: '#6b7280', marginTop: '0.5rem', fontSize: '0.875rem' }}>MXN</p>
          </div>

          {/* Recargar Saldo */}
          <div style={{ backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', padding: isMobile ? '1.25rem' : '2rem' }}>
            <h2 style={{ fontSize: isMobile ? '1rem' : '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Recargar Saldo</h2>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', marginBottom: '1rem' }}>
              {montosRapidos.map((m) => (
                <button key={m} onClick={() => setMonto(m.toString())} style={{
                  padding: isMobile ? '0.6rem' : '0.75rem',
                  border: monto === m.toString() ? '2px solid #ff8c00' : '1px solid #d1d5db',
                  backgroundColor: monto === m.toString() ? '#fff7ed' : 'white',
                  borderRadius: '0.375rem', cursor: 'pointer',
                  fontWeight: monto === m.toString() ? '600' : '400',
                  fontSize: isMobile ? '0.85rem' : '1rem'
                }}>${m}</button>
              ))}
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.875rem', color: '#374151', marginBottom: '0.25rem' }}>O ingresa otro monto:</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ fontSize: '1.25rem', color: '#6b7280' }}>$</span>
                <input type="number" min="50" value={monto} onChange={(e) => setMonto(e.target.value)} placeholder="Mínimo 50"
                  style={{ flex: 1, padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: isMobile ? '1rem' : '1.25rem', boxSizing: 'border-box' }} />
                <span style={{ color: '#6b7280' }}>MXN</span>
              </div>
            </div>

            {montoNum >= 50 && (
              <div style={{ backgroundColor: '#fffbeb', border: '1px solid #fbbf24', borderRadius: '0.375rem', padding: '0.75rem', marginBottom: '1rem', fontSize: '0.875rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                  <span style={{ color: '#92400e' }}>Monto a pagar:</span>
                  <span style={{ color: '#92400e', fontWeight: '600' }}>${montoNum.toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem' }}>
                  <span style={{ color: '#92400e', fontSize: isMobile ? '0.8rem' : '0.875rem' }}>Comisión procesamiento (4%):</span>
                  <span style={{ color: '#92400e', fontWeight: '600' }}>-${comisionMP.toFixed(2)}</span>
                </div>
                <div style={{ borderTop: '1px solid #fbbf24', paddingTop: '0.25rem', marginTop: '0.25rem', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#92400e', fontWeight: '700' }}>Saldo a recibir:</span>
                  <span style={{ color: '#065f46', fontWeight: '700', fontSize: '1rem' }}>${montoAcreditado.toFixed(2)}</span>
                </div>
              </div>
            )}

            <button onClick={handleRecargar} disabled={loading || !monto || saldoCongelado} style={{
              width: '100%', padding: '1rem',
              backgroundColor: loading || !monto || saldoCongelado ? '#fed7aa' : '#ff8c00',
              color: 'white', border: 'none', borderRadius: '0.375rem', fontWeight: '600', fontSize: '1rem',
              cursor: loading || !monto || saldoCongelado ? 'not-allowed' : 'pointer'
            }}>{saldoCongelado ? 'Recarga deshabilitada - Saldo congelado' : loading ? 'Procesando...' : 'Recargar con Mercado Pago'}</button>

            <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '1rem', textAlign: 'center' }}>
              Aceptamos tarjetas, OXXO, transferencia y más
            </p>
          </div>
        </div>

        {/* Pago por Transferencia */}
        <div style={{ border: '1px solid #e2e5ea', borderRadius: '12px', padding: isMobile ? '1.25rem' : '24px', backgroundColor: '#f8f9fb', marginTop: '24px' }}>
          <h3 style={{ fontSize: isMobile ? '1.1rem' : '1.25rem', fontWeight: '700', color: '#0f172a', marginBottom: '0.25rem', marginTop: 0 }}>Transferencia Bancaria</h3>
          <p style={{ color: '#64748b', fontSize: isMobile ? '0.85rem' : '0.95rem', marginBottom: '1rem' }}>Realiza tu transferencia y repórtala por WhatsApp para acreditar tu saldo</p>

          <div style={{ backgroundColor: 'white', padding: isMobile ? '12px' : '16px', borderRadius: '8px', marginBottom: '1rem' }}>
            {[
              { label: 'Banco', value: 'Banorte' },
              { label: 'Titular', value: 'GEMMA IMPORTACIONES DE MEXICO S.A. DE C.V.' },
              { label: 'No. de Cuenta', value: '1024222135', copyKey: 'cuenta' },
              { label: 'CLABE', value: '072150010242221353', copyKey: 'clabe' },
              { label: 'Concepto', value: 'Tu email de registro en EnviaTuPaquete.mx' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.5rem 0', borderBottom: i < 4 ? '1px solid #f1f5f9' : 'none', flexWrap: 'wrap', gap: '0.25rem' }}>
                <span style={{ color: '#64748b', fontSize: isMobile ? '0.8rem' : '0.875rem', minWidth: isMobile ? '100%' : 'auto' }}>{item.label}</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontWeight: '700', color: '#0f172a', fontSize: isMobile ? '0.85rem' : '0.95rem', wordBreak: 'break-all' }}>{item.value}</span>
                  {item.copyKey && (
                    <button onClick={() => copyToClipboard(item.value, item.copyKey)} style={{
                      background: 'none', border: '1px solid #d1d5db', borderRadius: '4px', padding: '2px 8px',
                      cursor: 'pointer', fontSize: '0.75rem', color: copied === item.copyKey ? '#065f46' : '#6b7280', whiteSpace: 'nowrap'
                    }}>{copied === item.copyKey ? 'Copiado' : 'Copiar'}</button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <p style={{ color: '#94a3b8', fontSize: '0.8rem', marginBottom: '1rem', lineHeight: '1.5' }}>
            Una vez realizada la transferencia, envía tu comprobante por WhatsApp. Tu saldo se acreditará en menos de 24 horas.
          </p>

          <div style={{ textAlign: 'center' }}>
            <a href="https://wa.me/526141964948?text=Hola%2C%20acabo%20de%20realizar%20una%20transferencia%20para%20recargar%20saldo%20en%20EnviaTuPaquete.mx"
              target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-block', backgroundColor: '#25D366', color: 'white', borderRadius: '10px', padding: '12px 24px', fontWeight: '700', fontSize: '1rem', textDecoration: 'none' }}>
              Reportar pago por WhatsApp
            </a>
          </div>
        </div>

        {/* Historial de Transacciones */}
        <div style={{ marginTop: isMobile ? '1rem' : '2rem', backgroundColor: 'white', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <div style={{ padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: isMobile ? '1rem' : '1.25rem', fontWeight: '600' }}>Historial de Movimientos</h2>
          </div>
          <div style={{ padding: isMobile ? '0.75rem' : '1.5rem' }}>
            {transacciones.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#6b7280' }}>No hay movimientos aún</p>
            ) : isMobile ? (
              /* Mobile: Card view */
              <div style={{ display: 'grid', gap: '0.75rem' }}>
                {transacciones.map((trans, index) => (
                  <div key={index} style={{ padding: '0.75rem', borderRadius: '0.375rem', border: '1px solid #e5e7eb', backgroundColor: '#f9fafb' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.375rem' }}>
                      <span style={{
                        padding: '0.2rem 0.5rem', borderRadius: '9999px', fontSize: '0.7rem', fontWeight: '600',
                        backgroundColor: trans.tipo === 'recarga' ? '#d1fae5' : '#fee2e2',
                        color: trans.tipo === 'recarga' ? '#065f46' : '#991b1b'
                      }}>{trans.tipo === 'recarga' ? 'Recarga' : 'Cargo'}</span>
                      <span style={{ fontWeight: '600', fontSize: '0.9rem', color: trans.tipo === 'recarga' ? '#065f46' : '#991b1b' }}>
                        {trans.tipo === 'recarga' ? '+' : '-'}${parseFloat(trans.monto).toFixed(2)}
                      </span>
                    </div>
                    <p style={{ fontSize: '0.8rem', color: '#6b7280', margin: '0.2rem 0' }}>{trans.descripcion}</p>
                    <p style={{ fontSize: '0.7rem', color: '#9ca3af', margin: 0 }}>{new Date(trans.created_at).toLocaleDateString('es-MX')}</p>
                  </div>
                ))}
              </div>
            ) : (
              /* Desktop: Table view */
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase' }}>Fecha</th>
                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase' }}>Tipo</th>
                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase' }}>Descripción</th>
                    <th style={{ padding: '0.75rem', textAlign: 'right', fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase' }}>Monto</th>
                  </tr>
                </thead>
                <tbody>
                  {transacciones.map((trans, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                      <td style={{ padding: '0.75rem', fontSize: '0.875rem' }}>{new Date(trans.created_at).toLocaleDateString('es-MX')}</td>
                      <td style={{ padding: '0.75rem', fontSize: '0.875rem' }}>
                        <span style={{ padding: '0.25rem 0.5rem', borderRadius: '9999px', fontSize: '0.75rem', backgroundColor: trans.tipo === 'recarga' ? '#d1fae5' : '#fee2e2', color: trans.tipo === 'recarga' ? '#065f46' : '#991b1b' }}>
                          {trans.tipo === 'recarga' ? 'Recarga' : 'Cargo'}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem', fontSize: '0.875rem', color: '#6b7280' }}>{trans.descripcion}</td>
                      <td style={{ padding: '0.75rem', fontSize: '0.875rem', textAlign: 'right', fontWeight: '600', color: trans.tipo === 'recarga' ? '#065f46' : '#991b1b' }}>
                        {trans.tipo === 'recarga' ? '+' : '-'}${parseFloat(trans.monto).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Saldo;